(() => {
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = () => reduced() ? 'auto' : 'smooth';

  const centerItem = (rail, item, animate = true) => {
    if (!rail || !item) return;
    const left = item.offsetLeft - Math.max(0, (rail.clientWidth - item.clientWidth) / 2);
    rail.scrollTo({ left: Math.max(0, left), behavior: animate ? behavior() : 'auto' });
  };

  const initZero = (root) => {
    if (!root || root.dataset.dtccMobileFlowZero === 'true') return;
    const headingWrap = root.querySelector('.dtcc-zero__grid > div:first-child');
    const media = root.querySelector('.dtcc-zero__product > .dtcc-zero__media');
    const heading = headingWrap?.querySelector('.dtcc-zero__heading');
    if (!headingWrap || !media || !heading) return;
    const mobileMedia = media.cloneNode(true);
    mobileMedia.classList.add('dtcc-zero__media--mobile');
    mobileMedia.setAttribute('aria-hidden', 'true');
    mobileMedia.tabIndex = -1;
    headingWrap.insertBefore(mobileMedia, heading);
    root.dataset.dtccMobileFlowZero = 'true';
  };

  const initLanguage = (root) => {
    if (!root || root.dataset.dtccMobileFlowLanguage === 'true') return;
    const controls = root.querySelector('.dtcc-language-switcher__controls');
    const panelsRail = root.querySelector('.dtcc-language-switcher__panels');
    const buttons = [...root.querySelectorAll('[data-language]')];
    const panels = [...root.querySelectorAll('[data-language-panel]')];
    const reveal = (target, animate = true) => {
      if (!mobile()) return;
      const button = buttons.find(b => b.dataset.language === target);
      centerItem(controls, button, animate);
      if (target === 'both') {
        panelsRail?.scrollTo({ left: 0, behavior: animate ? behavior() : 'auto' });
        return;
      }
      const panel = panels.find(p => p.dataset.languagePanel === target);
      if (panel && panelsRail) {
        panelsRail.scrollTo({ left: panel.offsetLeft, behavior: animate ? behavior() : 'auto' });
      }
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      requestAnimationFrame(() => reveal(button.dataset.language, true));
    }));
    requestAnimationFrame(() => {
      const active = buttons.find(b => b.classList.contains('is-active')) || buttons[0];
      if (active) reveal(active.dataset.language, false);
    });
    root.dataset.dtccMobileFlowLanguage = 'true';
  };

  const initCollectionTabs = (rail) => {
    if (!rail || rail.dataset.dtccMobileFlowTabs === 'true') return;
    const tabs = [...rail.querySelectorAll('.dtcc-folder-tab')];
    const active = tabs.find(tab => tab.matches('[aria-current="page"], .is-active'));
    requestAnimationFrame(() => {
      if (mobile() && active) centerItem(rail, active, false);
    });

    tabs.forEach(tab => tab.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      try { sessionStorage.setItem('dtcc-return-to-collection-tabs', '1'); } catch (error) {}
    }));

    let shouldReturn = false;
    try {
      shouldReturn = sessionStorage.getItem('dtcc-return-to-collection-tabs') === '1';
      if (shouldReturn) sessionStorage.removeItem('dtcc-return-to-collection-tabs');
    } catch (error) {}

    if (shouldReturn) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const headerOffset = mobile() ? 86 : 100;
        const top = window.scrollY + rail.getBoundingClientRect().top - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        if (active) centerItem(rail, active, false);
      }));
    }
    rail.dataset.dtccMobileFlowTabs = 'true';
  };

  const init = () => {
    document.querySelectorAll('[data-dtcc-zero-decision]').forEach(initZero);
    document.querySelectorAll('[data-dtcc-language-switcher]').forEach(initLanguage);
    document.querySelectorAll('.dtcc-folder-tabs').forEach(initCollectionTabs);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
